// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.modal-body-content[data-v-1a429256]{\n    color:#32325d;\n    font-size:1.025rem;\n}\n\n", ""]);
// Exports
module.exports = exports;
